import Vue from "vue";
import swal from "vue-sweetalert2";

Vue.use(swal);

const seguroTercero = {
  namespaced: true,
  state: () => ({
    // usernameOrEmail: "leoncyapp@holdingvml.net",
    // password: "$leoncyapp2022*",
    Username: "leoncyapp",
    Password: "WSL30ncy4pp",
    ClientId: 1021,
    // api: "https://appstool.co/bank-insurance-third/api",
    api: "https://appstool.co:8081/WebApiTrans/api",
    tokenSeguroTerceros: "",
  }),
  mutations: {
    SetTokenSeguroTerceros(state, payload) {
      state.tokenSeguroTerceros = payload;
    },
  },
  actions: {
    AuthSeguroTercero({ commit, getters }) {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Accept", "application/json");
      headers.append(
        "Access-Control-Allow-Origin",
        "https://digipats.digipats.com.co"
      );
      headers.append("Access-Control-Allow-Credentials", "true");

      const body = JSON.stringify({
        Username: getters.getUsernameOrEmail,
        Password: getters.getPassword,
        ClientId: getters.getClientId,
      });

      const requestOptions = {
        method: "POST",
        headers,
        body,
        redirect: "follow",
      };

      fetch(`${getters.getApi}/gettoken`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          commit("SetTokenSeguroTerceros", result);
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error) => {
          // console.log(error);
          Vue.swal({
            icon: "error",
            title: "Oops...",
            text: "El servicio de confirmación de plan no se encuentra disponible.",
          });
        });
    },
  },
  getters: {
    getUsernameOrEmail(state) {
      return state.Username;
    },
    getPassword(state) {
      return state.Password;
    },
    getClientId(state) {
      return state.ClientId;
    },
    getApi(state) {
      return state.api;
    },
    getTokenSeguroTerceros(state) {
      return state.tokenSeguroTerceros;
    },
  },
};

export default seguroTercero;
